import  RequestService  from '../requestService';
import { client } from '../../client';
import { Sone } from '../../../models';


export default class SoneService extends RequestService<Sone, 'sone'> {

    hentAktivBrukereUtenAngittSoneCount =  async (id: number) => client.get<number>(`${this.serviceName}/aktiv_brukere_uten_angitt_sone_count?soneId=${encodeURIComponent(id)}`);
    giBrukereTilgangTilSonen = async (id: number) => client.post<boolean>(`${this.serviceName}/gi_brukere_tilgang_til_sonen/${encodeURIComponent(id)}`, null);

}


